import { render, staticRenderFns } from "./decision-model.vue?vue&type=template&id=7dc0f78f&scoped=true"
import script from "./decision-model.vue?vue&type=script&lang=ts"
export * from "./decision-model.vue?vue&type=script&lang=ts"
import style0 from "./decision-model.vue?vue&type=style&index=0&id=7dc0f78f&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc0f78f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc0f78f')) {
      api.createRecord('7dc0f78f', component.options)
    } else {
      api.reload('7dc0f78f', component.options)
    }
    module.hot.accept("./decision-model.vue?vue&type=template&id=7dc0f78f&scoped=true", function () {
      api.rerender('7dc0f78f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/decision-model/decision-model.vue"
export default component.exports